import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { navigateBack } from 'flow/actions/navigate-actions';
import { LocationType } from 'flow/types/Location';
import BackButton from 'flow/components/ui-components/BackButton';

const BackButtonCallRecordPage = () => {
    const dispatch = useAppDispatch();
    const history = useHistory<LocationType>();

    const handleClick = useCallback(
        () => dispatch(navigateBack(history.location)),
        [dispatch, history],
    );

    return <BackButton onClick={handleClick} />;
};

export default BackButtonCallRecordPage;
